import ko from "knockout";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./checkboxReadonly.html";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";
import { selectLabel } from "flow/koHelpers/selectParam";

export interface ICheckboxReadonlyParams {
    attr?: MaybeObservableAttributes;
    checked: MaybeObservable<boolean>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
}

ko.components.register("ko-checkbox-readonly", {
    viewModel: function (params: ICheckboxReadonlyParams) {
        this.checked = params.checked;
        if (params.checked) {
            this.checked = params.checked;
        } else {
            this.checked = false;
        }

        if (params.meta || params.text) {
            this.text = selectLabel(params.meta, params.text);
        } else {
            this.text = "";
        }

        this.attributes = interceptAttributesWithDefaults({}, params.attr);
    },
    template: viewHtml,
    synchronous: true
});
